const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;

export async function executeRecaptchaV3(action: string): Promise<string> {
  if (!RECAPTCHA_SITE_KEY) {
    throw new Error('RECAPTCHA_NOT_CONFIGURED');
  }

  if (!document.querySelector('script[src*="www.google.com/recaptcha/api.js"]')) {
    await new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(RECAPTCHA_SITE_KEY!)}`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
      document.head.appendChild(script);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const grecaptcha = (window as any).grecaptcha;
  if (!grecaptcha || typeof grecaptcha.ready !== 'function') {
    throw new Error('RECAPTCHA_NOT_AVAILABLE');
  }

  await new Promise<void>((resolve) => grecaptcha.ready(() => resolve()));
  const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  if (!token) {
    throw new Error('RECAPTCHA_FAILED');
  }
  return token;
}
